module.exports = __webpack_public_path__ + "img/full7-min.91eb8525.png";